import React, { FC } from 'react';

// Utils
import { classNames } from '@sportal365/smp-widget-utils';

interface Props {
  percentValue: number;
  position: 'end' | 'start';
  backgroundColor: string;
  locator: string;
}

export const StatisticProgressBar: FC<Props> = ({ percentValue, position, backgroundColor, locator }) => {
  return (
    <div
      className={classNames(
        {
          'flex flex-1': true,
          'justify-end': position === 'end',
          'justify-start': position === 'start',
        },
        `${locator}-container`,
      )}
    >
      <div
        style={{ width: `${percentValue}%`, backgroundColor: `var(--colors-${backgroundColor})` }}
        className={classNames({ 'h-2 rounded-5': true }, `${locator}-percentage`)}
      />
    </div>
  );
};
